var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 42.058 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.029 0 6.5 13.167 14.531 2.111-10.517 10.253 2.482 14.472-13-6.833-13 6.833 2.491-14.472L.001 15.282l14.531-2.111Z"
  })));
};
export default SvgStar;